// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.server-error-modal {
  width: 380px;
}
.server-error-modal__image {
  display: block;
  width: 140px;
  margin: 0 auto 20px;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/components/server-error-modal/ServerErrorModal.less"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AACE;EACE,cAAA;EACA,YAAA;EACA,mBAAA;AACJ","sourcesContent":[".server-error-modal {\n  width: 380px;\n\n  &__image {\n    display: block;\n    width: 140px;\n    margin: 0 auto 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
